import { useEffect, useRef } from "react";
import { HLTVPlayer, PlayerHandle } from "./Player";
import { createParentBridge } from "./player/parentBridge";

// The bookmarklet's one iframe renders the player directly at this React route.
export const HLTVConceptEmbed = () => {
  const player = useRef<PlayerHandle>(null);
  const bridge = useRef<ReturnType<typeof createParentBridge>>();
  const latest = useRef({ status: "Loading live playlist…", height: 226 });
  const search = useRef(window.location.search).current;
  useEffect(() => {
    const connection = createParentBridge(
      window,
      (action: string, value: unknown) =>
        player.current?.command(action, value),
    );
    bridge.current = connection;
    connection.send("hltv-demo-status", latest.current.status);
    connection.send("hltv-demo-height", latest.current.height);
    return () => {
      connection.destroy();
      bridge.current = undefined;
    };
  }, []);
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        overflow: "auto",
        background: "#232a30",
        zIndex: 1,
      }}
    >
      <HLTVPlayer
        ref={player}
        search={search}
        onStatus={(value) => {
          latest.current.status = value;
          bridge.current?.send("hltv-demo-status", value);
        }}
        onHeight={(value) => {
          latest.current.height = value;
          bridge.current?.send("hltv-demo-height", value);
        }}
      />
    </div>
  );
};
